import React, { useEffect, useMemo, useState } from 'react';
import { Flex, Text } from '@chakra-ui/react';
import { useTranslation } from 'react-i18next';
import { useHistory } from 'react-router-dom';

import { getDocument } from '../../Utils/frontStageApi';
import { FileActionBar } from '../../Components/File/FileActionBar';
import { FileManagerTable, FileManagerDocument } from '../../Components/File/FileManagerTable';

const parseDateValue = (dateStr: string): number => {
  if (!dateStr) return 0;
  const normalized = dateStr.replace(/\./g, '/').replace(/-/g, '/');
  const parts = normalized.split('/').map(Number);
  if (parts.length >= 3) return new Date(parts[0], parts[1] - 1, parts[2]).getTime();
  const parsed = new Date(dateStr).getTime();
  return Number.isNaN(parsed) ? 0 : parsed;
};

const FileManagerPage: React.FC = () => {
  const { t } = useTranslation();
  const history = useHistory();
  const [documents, setDocuments] = useState<FileManagerDocument[]>([]);
  const [searchText, setSearchText] = useState<string>('');
  const [sortDirection, setSortDirection] = useState<'desc' | 'asc'>('desc');

  useEffect(() => {
    getDocument(0).then((data: any) => {
      if (data && Array.isArray(data.list)) setDocuments(data.list);
    });
  }, []);

  const filtered = useMemo(() => {
    const f = searchText.trim() === '' ? documents : documents.filter((i) => i.title.includes(searchText.trim()));
    return [...f].sort((a, b) => {
      const diff = parseDateValue(a.date) - parseDateValue(b.date);
      return sortDirection === 'desc' ? -diff : diff;
    });
  }, [documents, searchText, sortDirection]);

  return (
    <Flex w="100%" direction="column" align="center" pt="50px" pb="100px">
      <Text
        fontFamily="'Open Sans', sans-serif"
        fontSize="30px"
        fontWeight={600}
        lineHeight="133%"
        letterSpacing="0.01em"
        color="#000000"
        textAlign="center"
      >
        {t('file.pageTitle')}
      </Text>
      <FileActionBar
        mt="50px"
        searchText={searchText}
        onSearchChange={setSearchText}
        onAdd={() => history.push('/bs/document/create')}
      />

      <FileManagerTable
        mt="22px"
        documents={filtered}
        sortDirection={sortDirection}
        onSortToggle={() => setSortDirection((p) => (p === 'desc' ? 'asc' : 'desc'))}
      />
    </Flex>
  );
};

export default FileManagerPage;
